export default "__VITE_ASSET__Btvd0FRg__"